import { format } from 'date-fns';
import * as React from 'react';

import { EventView } from '@ndvr/customer-api';

import { CalendarIcon } from '../../../components/Icons';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from '../../../components/ui/sheet';
import EventCalendarEventCard from './EventCalendarEventCard';

export interface EventCalendarDetailsSheetProps {
    date: Date | null;
    events: EventView[];
    trigger?: React.ReactNode;
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
    onOpenEventDetails?: (event: EventView) => void;
}

export const EventCalendarDetailsSheet = (props: EventCalendarDetailsSheetProps) => {
    const headerDate = props.date;

    return (
        <Sheet open={props.open} onOpenChange={props.onOpenChange}>
            {props.trigger && <SheetTrigger asChild>{props.trigger}</SheetTrigger>}
            <SheetContent side="right" className="w-3/4 overflow-y-auto sm:w-96" aria-describedby={undefined}>
                <SheetHeader>
                    <SheetTitle>
                        <span className="text-accent text-lg font-semibold">
                            {headerDate ? format(headerDate, 'EEEE, MMMM d, yyyy') : ''}
                        </span>
                    </SheetTitle>
                </SheetHeader>

                <div className="pt-4">
                    {props.events.length > 0 ? (
                        props.events.map((event) => (
                            <EventCalendarEventCard
                                key={event.eventGUID}
                                event={event}
                                onOpenDetails={props.onOpenEventDetails}
                            />
                        ))
                    ) : (
                        <div className="text-muted-foreground py-8 text-center">
                            <CalendarIcon className="mx-auto mb-4 h-12 w-12 opacity-50" />
                            <p>No events for selected date</p>
                        </div>
                    )}
                </div>
            </SheetContent>
        </Sheet>
    );
};

export default EventCalendarDetailsSheet;
